import React, { Component } from 'react'
import { graphql, compose } from 'react-apollo'
import UPDATE_PLAN from './../../../../graphql/UpdatePlanByPrice.graphql'
import { translate } from 'react-i18next'

class TravelerPriceModal extends Component {
  updateOrderPrice() {
    const { modalClose, updateCustomizedPlan, order } = this.props
    updateCustomizedPlan({
      variables: {
        id: order.id,
        orderStatus: 'Charged',
        totalAmount: order.newTotalAmount
      }
    })
    modalClose()
  }

  render() {
    const { modalClose, order, t } = this.props
    return (
      <div>
        <i className="modal-close" onClick={modalClose} />
        <div className="modal-body">
          <p>{t('accept_change')}</p>
          <div className="items">
            <div className="row">
              <div className="column-7">{t('total_price_before')}</div>
              <div className="column-5">${order.totalAmount}</div>
            </div>
            <div className="row">
              <div className="column-7">{t('additional_charges')}</div>
              <div className="column-5">${order.additionalCharges}</div>
            </div>
            <div className="row">
              <div className="column-7">{t('new_total_price')}</div>
              <div className="column-5">${order.newTotalAmount}</div>
            </div>
          </div>

          <p>{order.newPriceComments}</p>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn order-action" onClick={() => this.updateOrderPrice()}>
            {t('approve')}
          </button>
        </div>
      </div>
    )
  }
}

const enhance = compose(
  translate('orders'),
  graphql(UPDATE_PLAN, {
    name: 'updateCustomizedPlan'
  })
)
export default enhance(TravelerPriceModal)



// WEBPACK FOOTER //
// src/components/Guru/Orders/Modals/TravelerPriceModal.jsx